module.exports = __webpack_public_path__ + "static/box_red-7f702f267d3358de76653e301fc64e76.gif";